import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getQuoteCargoTypesListAPI = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/cargo-types`,
    method: 'get',
  });
};

export type QuoteCargoTypesListResponse = {
  lookupCodeId: string;
  displayValue: string;
}[];

export const fetchQuoteCargoTypesList = async (): Promise<QuoteCargoTypesListResponse> => {
  const response: AxiosResponse<QuoteCargoTypesListResponse> = await getQuoteCargoTypesListAPI();
  return response.data;
};
